module.exports = __webpack_public_path__ + "static/media/maestro_logo_png_light.4b906372.png";